import {
  SET_EMPLOYEE_DETAILS,
  Action,
  UPDATE_EMPLOYEE_ADDRESS,
} from "../actions/employee";

const initialState = {
  details: {},
};

export default function employee(state = initialState, action: Action): any {
  switch (action.type) {
    case SET_EMPLOYEE_DETAILS:
      return {
        ...state,
        details: action.state,
      };
    case UPDATE_EMPLOYEE_ADDRESS:
      return {
        ...state,
        details: {
          ...state.details,
          home_address: action.state,
        },
      };
    default:
      return state;
  }
}
